<div #dropdown class="card-input flex items-center space-x-4" style="position: relative;">
      <span class="text-xs w-100-px font-semibold">{{ label }}</span>
      <button 
        (click)="toggleDropdown()" 
        class="rounded-md py-3 pl-0 minw-200-px flex justify-between items-center h-30-px cursor-pointer">
        <span 
          *ngIf="!displayText" 
          class="barlow text-black text-xs p-5 italic">
          {{ placeholder }}
        </span>
        <span 
          *ngIf="displayText" 
          class="barlow text-black text-xs p-5 italic">
          {{ displayText }}
        </span>
        <span class="material-icons violet-text">arrow_drop_down</span>
      </button>
      <div 
        class="dropdown-content" 
        [ngClass]="{ 'show': isDropdownOpen }"
      >
        <!-- Default Option -->
        <label 
          *ngIf="showDefaultOption"
          [ngClass]="{ 'active': defaultChecked }" 
          class="tracking-wide focus:outline-none italic text-xs"
        >
          <div class="sort">
            {{ defaultOptionLabel }}
            <input 
              type="checkbox" 
              class="checkbox" 
              [(ngModel)]="defaultChecked" 
              (change)="onDefaultChange()">
            <span class="checkmark"></span>
          </div>
        </label>

        <!-- Dynamic Options -->
        <label 
  *ngFor="let option of getValidOptions()"
  [ngClass]="{ 'active': isOptionActive(option.value!) }" 
  class="tracking-wide focus:outline-none italic text-xs"
>
  <div class="sort">
    {{ option.label }}
    <input 
      type="checkbox" 
      class="checkbox" 
      [value]="option.value" 
      [checked]="isOptionChecked(option.value!)"
      (change)="onOptionChange(option.value!)"
    >
    <span class="checkmark"></span>
  </div>
</label>
      </div>
    </div>